import { render, staticRenderFns } from "./OrderCreatorTemplate.vue?vue&type=template&id=473f06eb&scoped=true&"
import script from "./OrderCreatorTemplate.vue?vue&type=script&lang=js&"
export * from "./OrderCreatorTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "473f06eb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('473f06eb')) {
      api.createRecord('473f06eb', component.options)
    } else {
      api.reload('473f06eb', component.options)
    }
    module.hot.accept("./OrderCreatorTemplate.vue?vue&type=template&id=473f06eb&scoped=true&", function () {
      api.rerender('473f06eb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Papers/pages/Paper/components/Templates/OrderCreatorTemplate.vue"
export default component.exports